module.exports = __webpack_public_path__ + "static/media/logout_blue.790632aa.svg";